var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Components } from 'formiojs';
var Component = Components.components.component;
import editForm from './Captcha.form';
import * as _ from 'lodash';
var CaptchaComponent = /** @class */ (function (_super) {
    __extends(CaptchaComponent, _super);
    function CaptchaComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaptchaComponent.schema = function () {
        var extend = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extend[_i] = arguments[_i];
        }
        return Component.schema.apply(Component, __spreadArrays([{
                type: 'captcha',
                key: 'captcha',
                label: 'CAPTCHA'
            }], extend));
    };
    Object.defineProperty(CaptchaComponent, "builderInfo", {
        get: function () {
            return {
                title: 'CAPTCHA',
                group: 'premium',
                icon: 'refresh',
                documentation: '/userguide/form-building/premium-components',
                weight: 40,
                schema: CaptchaComponent.schema()
            };
        },
        enumerable: false,
        configurable: true
    });
    CaptchaComponent.savedValueTypes = function () {
        return [];
    };
    Object.defineProperty(CaptchaComponent, "conditionOperatorsSettings", {
        get: function () {
            return __assign(__assign({}, _super.conditionOperatorsSettings), { operators: ['isEmpty', 'isNotEmpty'] });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CaptchaComponent, "serverConditionSettings", {
        get: function () {
            return CaptchaComponent.conditionOperatorsSettings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CaptchaComponent.prototype, "captchaType", {
        get: function () {
            return this.component.provider === 'cloudflare' ? 'CAPTCHA' : 'reCAPTCHA';
            ;
        },
        enumerable: false,
        configurable: true
    });
    CaptchaComponent.prototype.render = function () {
        this.captchaResult = null;
        if (this.options.building) {
            return _super.prototype.render.call(this, this.captchaType);
        }
        var siteKey = _.get(this.root.form, 'settings.captcha.siteKey');
        if (this.options.readOnly || this.component.provider === 'google' || !siteKey) {
            return _super.prototype.render.call(this, '', true);
        }
        return _super.prototype.render.call(this, "<div id='cf-turnstile' " + (this.component.isVisibleVerification ? "style='min-height:65px'" : '') + "></div>", true);
    };
    Object.defineProperty(CaptchaComponent.prototype, "skipInEmail", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CaptchaComponent.prototype.renderCloudFlareWidget = function (provider, actionName, siteKey, resolve, reject) {
        var _this = this;
        this.cloudflareId = provider.render('#cf-turnstile', {
            action: actionName,
            sitekey: siteKey,
            callback: function (token) {
                _this.sendVerificationRequest(token, 'captcha').then(function (_a) {
                    var verificationResult = _a.verificationResult, token = _a.token;
                    _this.captchaResult = __assign(__assign({}, verificationResult), { token: token });
                    _this.isLoading = false;
                    _this.updateValue(_this.captchaResult);
                    _this.captchaVerifiedPromise = resolve(verificationResult);
                });
            },
            'error-callback': function (err) {
                _this.isLoading = false;
                // tslint:disable-next-line: no-console
                console.warn("Turnstile client-side error code:" + err);
                _this.setCustomValidity('CAPTCHA: Turnstile client-side error.');
                _this.captchaVerifiedPromise = reject();
            },
        });
    };
    CaptchaComponent.prototype.verify = function (actionName) {
        var _this = this;
        if (this.options.readOnly || this.options.building) {
            return;
        }
        var captchaType = this.captchaType.toLowerCase();
        var siteKey = _.get(this.root.form, "settings." + captchaType + ".siteKey");
        if (!siteKey) {
            // tslint:disable-next-line: no-console
            console.warn('There is no Site Key specified in settings in form JSON');
            return;
        }
        if (!this.captchaApiReady) {
            switch (this.component.provider) {
                case 'cloudflare':
                    this.captchaApiReady = Formio.requireLibrary('cloudflareTurnstile', 'turnstile', 'https://challenges.cloudflare.com/turnstile/v0/api.js', true);
                    break;
                case 'google':
                default:
                    var recaptchaApiScriptUrl = "https://www.google.com/recaptcha/api.js?render=" + _.get(this.root.form, 'settings.recaptcha.siteKey');
                    this.captchaApiReady = Formio.requireLibrary('googleRecaptcha', 'grecaptcha', recaptchaApiScriptUrl, true);
            }
        }
        if (this.captchaApiReady) {
            this.captchaVerifiedPromise = new Promise(function (resolve, reject) {
                _this.captchaApiReady
                    .then(function (provider) {
                    if (!_this.isLoading) {
                        _this.isLoading = true;
                        switch (_this.component.provider) {
                            case 'cloudflare':
                                _this.cloudflareProvider = provider;
                                if (_this.currentForm.getComponentById(_this.id)) {
                                    _this.renderCloudFlareWidget(provider, actionName, siteKey, resolve, reject);
                                }
                                break;
                            case 'google':
                            default:
                                provider.ready(_.debounce(function () {
                                    provider
                                        .execute(siteKey, {
                                        action: actionName
                                    })
                                        .then(function (token) {
                                        return _this.sendVerificationRequest(token).then(function (_a) {
                                            var verificationResult = _a.verificationResult, token = _a.token;
                                            _this.captchaResult = __assign(__assign({}, verificationResult), { token: token });
                                            _this.updateValue(_this.captchaResult);
                                            return resolve(verificationResult);
                                        });
                                    })
                                        .catch(function () {
                                        _this.isLoading = false;
                                    });
                                }, 1000));
                        }
                    }
                })
                    .catch(function () {
                    _this.isLoading = false;
                    return reject();
                });
            }).then(function () {
                _this.isLoading = false;
            });
        }
    };
    CaptchaComponent.prototype.beforeSubmit = function () {
        var _this = this;
        if (this.captchaVerifiedPromise) {
            return this.captchaVerifiedPromise
                .then(function () { return _super.prototype.beforeSubmit.call(_this); });
        }
        return _super.prototype.beforeSubmit.call(this);
    };
    CaptchaComponent.prototype.sendVerificationRequest = function (token, type) {
        if (type === void 0) { type = 'recaptcha'; }
        return Formio.makeStaticRequest(Formio.projectUrl + "/captcha?captchaToken=" + token + "&captchaType=" + type)
            .then(function (verificationResult) { return ({ verificationResult: verificationResult, token: token }); });
    };
    CaptchaComponent.prototype.checkComponentValidity = function (data, dirty, row, options, errors) {
        if (options === void 0) { options = {}; }
        if (errors === void 0) { errors = []; }
        data = data || this.rootValue;
        row = row || this.data;
        var _a = options.async, async = _a === void 0 ? false : _a;
        // Verification could be async only
        if (!async) {
            return _super.prototype.checkComponentValidity.call(this, data, dirty, row, options, errors);
        }
        var componentData = row[this.component.key];
        if (!componentData || !componentData.token) {
            this.setCustomValidity(this.component.label + ": Token is not specified in submission");
            return Promise.resolve(false);
        }
        if (!componentData.success) {
            this.setCustomValidity(this.component.label + ": Token validation error");
            return Promise.resolve(false);
        }
        return Promise.resolve(true);
    };
    CaptchaComponent.prototype.normalizeValue = function (newValue) {
        // If a captcha result has already been established, then do not allow it to be reset.
        return this.captchaResult ? this.captchaResult : newValue;
    };
    CaptchaComponent.prototype.destroy = function () {
        var _a;
        if (this.cloudflareId && typeof ((_a = this.cloudflareProvider) === null || _a === void 0 ? void 0 : _a.remove) === 'function') {
            this.cloudflareProvider.remove(this.cloudflareId);
        }
        _super.prototype.destroy.call(this);
    };
    CaptchaComponent.editForm = editForm;
    return CaptchaComponent;
}(Component));
export default CaptchaComponent;
